// index.js
import Vue from "vue";

Vue.component("LeadInsuranceMoveForms", () => import("./MoveForms.vue"));
Vue.component("LeadInsuranceShow", () => import("./Show.vue"));
Vue.component("LeadInsuranceTimeline", () => import("./Timeline.vue"));
// Vue.component("TransferLeadInsurance", () => import("./Transfer.vue"));
